<template>
  <div id="full-list">
    <ul v-if="fullResult && fullResult.length > 0">
      <li
        class="cursor-pointer"
        v-for="result in fullResult"
        :key="result.type + '.' + result.id"
        @click="selectOption({ type: result.type, id: result.id })"
      >
        <a v-html="result.name"></a>
        <span class="user-type" v-if="contacttype[result.type] !== ''"
          >({{ contacttype[result.type] }})</span
        >
      </li>
    </ul>

    <div v-else>No contacts</div>
  </div>
</template>

<script>
import { listMixin } from "../../../../../mixins/listMixin";

export default {
  mixins: [listMixin],
  props: {
    hideFullResultList: Function, // Hide the full result list
    hideResult: Function // Hide the result list
  },
  data() {
    return {
      contacttype: {
        person: "Client",
        other_event: "Other Person",
        group_appointment: "Group",
        event_appointment: "Event"
      }
    };
  }
};
</script>

<style scoped>
/* CSS HERE */
#full-list {
  width: 98%;
  margin: 20px auto;
}
#full-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#full-list ul li {
  margin: 15px 0;
}
.user-type {
  float: right;
  color: gray;
  font-style: italic;
  font-size: small;
}
</style>
